<span>
    <span class="m-l-10">{{ options.displayItem(item) }}</span>
</span>